'use client';

import { c as _c } from "react/compiler-runtime";
import type { HeroConnection } from './utils';
import type React from 'react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { FlexRow } from 'src/components/Atoms/FlexBox';
import StatusDot from './StatusDot';
import { CONNECTION_STATUS_LABELS } from './utils';
interface ConnectionStatusChipProps {
  connection: HeroConnection;
  connectionsUrl: string;
  onNavigate: (url: string) => void;
}
const TONES = {
  active: 'positive',
  pending: 'waiting',
  lost: 'negative'
} as const;
const ConnectionStatusChip: React.FC<ConnectionStatusChipProps> = t0 => {
  const $ = _c(17);
  const {
    connection,
    connectionsUrl,
    onNavigate
  } = t0;
  const t1 = TONES[connection.status];
  let t2;
  if ($[0] !== t1) {
    t2 = <StatusDot tone={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${connection.name} · ${CONNECTION_STATUS_LABELS[connection.status]}`;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <Chip size="small" variant="outlined" icon={t2} label={t3} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== connection.status || $[6] !== connectionsUrl || $[7] !== onNavigate) {
    t5 = connection.status === "pending" && <Button variant="text" size="small" onClick={() => onNavigate(connectionsUrl)}>Complete</Button>;
    $[5] = connection.status;
    $[6] = connectionsUrl;
    $[7] = onNavigate;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== connection.status || $[10] !== connectionsUrl || $[11] !== onNavigate) {
    t6 = connection.status === "lost" && <Button variant="outlined" size="small" onClick={() => onNavigate(connectionsUrl)}>Reconnect</Button>;
    $[9] = connection.status;
    $[10] = connectionsUrl;
    $[11] = onNavigate;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <FlexRow sx={_temp}>{t4}{t5}{t6}</FlexRow>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default ConnectionStatusChip;
function _temp(theme) {
  return {
    alignItems: "center",
    gap: theme.sizes.spacing["02"]
  };
}